// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__bpQDz","navbar":"Layout_navbar__hJdoL","body":"Layout_body__E0gE4"};